import React from 'react'

const ArrowIncrement = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.6666 4.66699H14.6666V8.66699" stroke="url(#paint0_linear_2596_7833)" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M14.6667 4.66699L9.00004 10.3337L5.66671 7.00033L1.33337 11.3337" stroke="url(#paint1_linear_2596_7833)" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  <defs>
    <linearGradient id="paint0_linear_2596_7833" x1="7.91663" y1="11.307" x2="17.4794" y2="10.2792" gradientUnits="userSpaceOnUse">
      <stop stopColor="#A8E6CF"/>
      <stop offset="1" stopColor="#1DBF73"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2596_7833" x1="-7.83329" y1="15.7337" x2="22.9866" y2="9.10872" gradientUnits="userSpaceOnUse">
      <stop stopColor="#A8E6CF"/>
      <stop offset="1" stopColor="#1DBF73"/>
    </linearGradient>
  </defs>
</svg>
  )
}

export default ArrowIncrement  